import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { DynamicQuestion } from '~app/inscription/store/cotisation-form/inscription.model';
import { LocalizedString } from '~app/shared/model/localized-string.model';
import { AbstractDynamicInput } from '../abstract-dynamic-input';

@Component({
    selector: 'odq-dynamic-radio-group',
    templateUrl: './dynamic-radio-group.component.html',
    styleUrls: ['./dynamic-radio-group.component.scss'],
    standalone: false
})
export class DynamicRadioGroupComponent extends AbstractDynamicInput implements OnInit {

  @Input()
  summary: boolean = false;

  @Input()
  questions: DynamicQuestion[] = [];

  @Input()
  formControls: Map<number, UntypedFormControl>

  @Output()
  onChange = new EventEmitter();

  questionModel: any;

  //Initiate model with saved value 
  ngOnInit(): void {
    this.questions.forEach(question => {
      if (this.formControls.get(question.questionNumber)?.value === 'True') {
        this.questionModel = question.questionNumber;
      }
    })
  }

  // Update form control values
  onModelChange() {
    this.questions.forEach(question => {
      const ctrl = this.formControls.get(question.questionNumber);
      ctrl.patchValue(this.questionModel === question.questionNumber ? 'True' : 'False');
    });

    this.onChange.emit();
  }

  // Summary label
  getSummaryLabel(): LocalizedString {
    return this.questions.find(q => q.questionNumber === this.questionModel)?.summaryLabel;
  }
}
